import React, {Fragment} from 'react'
import List from '../../../../components/Purchasing/Voucher/Lines/List'
import VouchersLinesModal from '../../../../components/Purchasing/Voucher/Lines/VouchersLinesModal'

function VouchersLines(props) {
  return (
    <Fragment>
      <VouchersLinesModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

export default VouchersLines
